// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import XngZone from "@west/App/Components/Common/XngZone";
import XngSticky from "@west/App/Components/XngSticky";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface OnePageCheckoutConfirmationPageContainerStyles {
    container?: GridContainerProps;
    topGridItem?: GridItemProps;
    leftGridItem?: GridItemProps;
    spaceGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
}

export const containerStyles: OnePageCheckoutConfirmationPageContainerStyles = {
    topGridItem: { width: 12 },
    leftGridItem: {
        width: [12, 12, 6, 7, 7],
        css: css`
            & > div > div:not(:last-child) {
                padding-bottom: 30px;
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
    spaceGridItem: { width: [0, 0, 1, 1, 1] },
    rightGridItem: { width: [12, 12, 5, 4, 4] },
    bottomGridItem: {
        width: 12,
        css: css`
            & > div > div:first-child {
                padding-top: 30px;
                border-top: 1px solid ${getColor("common.border")};
            }
        `,
    },
};

const styles = containerStyles;

const OnePageCheckoutConfirmationPageContainer = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftGridItem}>
                <Zone zoneName="Content0" contentId={id} />
            </StyledWrapper>
            <StyledWrapper {...styles.rightGridItem}>
                <XngSticky>
                    <XngZone zoneName="ContentTotal" contentId={id} hint={translate("Order Summary")} />
                </XngSticky>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutConfirmationPageContainer,
    definition: {
        displayName: "Page Container",
        group: "One Page Checkout Confirmation",
        allowedContexts: ["OnePageCheckoutConfirmationPage"],
    },
};

export default widgetModule;
